module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/DIGITAL ART-11b469efb37ff76dcabb94904b66ac84.png";